export const BACK_TO_DASHBOARD_LABEL = 'Back to dashboard';
